// AUDIT-27 parça 2/3 — Frontend Sentry init.
// REACT_APP_SENTRY_DSN env tanımlıysa aktif olur, aksi halde no-op.
//
// Index.js'in en başında `import './sentry';` ile çağrılır.

import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || 'development',
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_RATE || '0.1'),
    sendDefaultPii: false,
    // Yaygın gürültüyü filtrele
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Non-Error promise rejection captured',
    ],
  });
  // eslint-disable-next-line no-console
  console.log('[sentry] Aktif —', process.env.NODE_ENV);
} else {
  // Geliştirmede sessiz; production'da DSN olmaması da bilerek devre dışı sayılır.
  // eslint-disable-next-line no-console
  console.log('[sentry] DSN yok — devre dışı.');
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
export default Sentry;
